import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "./FontAwesomeIcon";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { useEffect, useState } from "react";
import classnames from "classnames";
import { DoraTimeInput } from "./DoraTimeInput";
import "./DoraTimeRangePicker.scss";
export const DoraTimeRangePicker = (props) => {
    const { onChange, value: propsValue, error, disabled } = props;
    const [value, setValue] = useState({
        start: props.value?.start || "",
        end: props.value?.end || "",
    });
    useEffect(() => {
        if (propsValue.start !== value.start || propsValue.end !== value.end) {
            setValue(propsValue);
        }
    }, [propsValue, setValue]);
    const onStartTimeChange = (start) => {
        const newValue = {
            ...value,
            start,
        };
        setValue(newValue);
        onChange(newValue);
    };
    const onEndTimeChange = (end) => {
        const newValue = {
            ...value,
            end,
        };
        setValue(newValue);
        onChange(newValue);
    };
    const componentClasses = classnames("dora-time-range-picker", {
        "dora-time-range-picker--error": error,
        "dora-time-range-picker--disabled": disabled,
    });
    const spacerClasses = classnames("dora-time-range-picker__spacer", {
        "dora-time-range-picker__input--with-value": value.start || value.end,
    });
    return (_jsxs("div", { className: componentClasses, children: [_jsx(FontAwesomeIcon, { className: "dora-time-range-picker__clock-icon", icon: faClock }), _jsxs("div", { className: "flex justify-between items-center w-full", children: [_jsx(DoraTimeInput, { value: value.start, disabled: disabled, onChange: onStartTimeChange, style: disabled ? { cursor: "not-allowed" } : {} }), _jsx("div", { className: spacerClasses, children: "\u00A0" }), _jsx(DoraTimeInput, { value: value.end, disabled: disabled, onChange: onEndTimeChange, style: disabled ? { cursor: "not-allowed" } : {} })] })] }));
};
export const UFDoraTimeRangePicker = (props) => {
    const { name, setValue, getValues, error, disabled } = props;
    const value = getValues(name);
    let v = { start: "", end: "" };
    if (value && typeof value === "string") {
        const [start, end] = value.split(" - ");
        v = { start, end };
    }
    const onChange = (e) => {
        let v = `${e.start} - ${e.end}`;
        if (v === " - ") {
            v = "";
        }
        setValue(name, v);
    };
    return (_jsx(DoraTimeRangePicker, { value: v, onChange: onChange, error: error, disabled: disabled }));
};
//# sourceMappingURL=DoraTimeRangePicker.js.map